
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Typeahead = require('typeahead.js/dist/typeahead.jquery.min.js');
window.Bloodhound = require('typeahead.js/dist/bloodhound.min.js');
require('bootstrap-tagsinput');
require('owl.carousel');
require('nestable2');

// PLayer specific.
require( 'jquery-ui/ui/core.js' );
require( 'jquery-ui/ui/widget.js' );
require( 'jquery-ui/ui/widgets/mouse.js' );
require( 'jquery-ui/ui/widgets/droppable.js' );
require( 'jquery-ui/ui/widgets/droppable.js' );
